<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g fill="none" stroke="var(--stroke-color)" stroke-width="6" stroke-linecap="round" stroke-linejoin="round">
    
    <path d="M 26 23 C 26 13, 74 13, 74 23 C 74 33, 26 33, 26 23 Z" />
    <path d="M 26 23 L 26 38 C 26 48, 74 48, 74 38 L 74 23" />
    <path d="M 26 38 L 26 53 C 26 63, 74 63, 74 53 L 74 38" />
    <path d="M 26 53 L 26 68 C 26 78, 74 78, 74 68 L 74 53" />

    <path d="M 26 35 L 12 35 L 12 28" />
    <circle cx="12" cy="25" r="3" fill="#FFFFFF" />

    <path d="M 26 50 L 12 50 L 12 57" />
    <circle cx="12" cy="60" r="3" fill="#FFFFFF" />

    <path d="M 74 26 L 88 26 L 88 19" />
    <circle cx="88" cy="16" r="3" fill="#FFFFFF" />

    <path d="M 74 41 L 88 41 L 88 48" />
    <circle cx="88" cy="51" r="3" fill="#FFFFFF" />

    <line x1="50" y1="68" x2="50" y2="75" />
    <line x1="11" y1="75" x2="89" y2="75" />
    
    <line x1="11" y1="75" x2="11" y2="82" />
    <line x1="37" y1="75" x2="37" y2="82" />
    <line x1="63" y1="75" x2="63" y2="82" />
    <line x1="89" y1="75" x2="89" y2="82" />

    <rect x="3" y="82" width="16" height="15" rx="1" fill="#FFFFFF" />
    <rect x="29" y="82" width="16" height="15" rx="1" fill="#FFFFFF" />
    <rect x="55" y="82" width="16" height="15" rx="1" fill="#FFFFFF" />
    <rect x="81" y="82" width="16" height="15" rx="1" fill="#FFFFFF" />

  </g>
</svg>
